<template>
  <dv-border-box-8 :dur="durTime">
    <div class="amap-page-container">
      <el-amap
        vid="amapDemo"
        :zoom="zoom"
        :center="center"
        class="amap-demo"
        ref="amapView"
        :map-style="mapStyle"
      >
        <el-amap-marker
          v-for="(item) in markers"
          :position="item.position"
          :clickable="item.clickable"
          :visible="item.visible"
          :draggable="item.draggable"
          :content="item.content"
          :icon="item.icon"
          :label="item.label"
          :events="item.events"
        ></el-amap-marker>

        <!--        <el-amap-info-window :position="currentWindow.position"-->
        <!--                             :content="currentWindow.content"-->
        <!--                             :visible="currentWindow.visible"-->
        <!--                             :events="currentWindow.events"-->
        <!--                             :offset="[8,-32]">-->
        <!--        </el-amap-info-window>-->
      </el-amap>
    </div>
  </dv-border-box-8>
</template>

<script>
  import { mapState } from 'vuex'
  import VueAMap from 'vue-amap'

  export default {
    name: 'ScwlmapVehicle',
    computed: {
      ...mapState('bigScreenData', ['locationVehicle'])
    },
    watch: {
      locationVehicle: {
        handler: function (val) {
          console.log(val)
          let markers = []
          for (let li of val) {
            let item = {
              position: [li.lng, li.lat],
              visible: true,
              draggable: false,
              clickable: true,
              // template: '<span>1</span>',
              name: li.address,
              label: {
                content: `<div style="font-size: 12px;margin: -2px;padding:0; box-sizing: border-box; color: #000;">${li.vehicleNo}</div>  `,
                offset: [-18, 20]
              },
              icon: require('@/assets/s_ico4.png'),
              events: {
                init: (e) => {

                },
                click: (e) => {
                  // let htmlInfo = `<div style="margin-bottom:5px;color: #000">车牌号：${li.vehicleNo}</div>`
                  // if (li.tWaybill) {
                  //   htmlInfo = htmlInfo + `<div style="margin-bottom:5px;color: #ff4949">司机信息：${li.tWaybill.driverName}${li.tWaybill.driverUsername}</div>
                  //       <div style="margin-bottom:5px;color: #ff4949">运单号：${li.tWaybill.waybillNo}</div>`
                  // }
                  // htmlInfo = htmlInfo + `<div style="margin-bottom:5px;color: #000"">定位时间：${li.locationTime}</div>
                  //   <div style="margin-bottom:5px;color: #000"">车辆状态：${li.state == 1 ? '在线' : li.state == 2 ? '停车车线' : '离线'}</div>
                  //   <div style="margin-bottom:5px;color: #000"">位置：${li.address == null ? '' : li.address}</div>`
                  // this.currentWindow.position = [li.lng, li.lat]
                  // this.currentWindow.content = htmlInfo
                  // this.currentWindow.visible = true
                }
              }
            }
            markers.push(item)
          }
          this.markers = markers
        },
        deep: true
      }
    },
    data () {
      let that = this
      return {
        durTime: 4,
        zoom: 11, // 初始化地图层级
        mapStyle: 'amap://styles/darkblue',
        center: [108.95346, 34.265725],
        resizeEnable: false, // 是否监控地图容器尺寸变化
        markers: [],
        // currentWindow: {
        //   position: [116.405994, 39.915378],
        //   content: '<div class="red">Hi! I am here!</div>',
        //   visible: false
        // }
        // events: {
        //   init (amap) {
        //     var boundsArray = []
        //     that.markers.forEach((m) => {
        //       boundsArray.push(new AMap.LngLat(m.position[0], m.position[1]))
        //     })
        //     var bounds = new AMap.ArrayBounds(boundsArray)
        //     amap.setBounds(bounds)
        //   },
        // },
        // currentMarker: {},
      }
    },
    created () {
      // this.$nextTick(() => {
      //   // console.log(this.locationVehicle)
      //   let markers = []
      //   for (let li of this.locationVehicle) {
      //     let item = {
      //       position: [li.lng, li.lat],
      //       visible: true,
      //       draggable: false,
      //       template: '<span>1</span>',
      //       name: li.address,
      //
      //       icon: require('@/assets/s_ico4.png')
      //     }
      //
      //     markers.push(item)
      //   }
      //   this.markers = markers
      // })
    },
    methods: {
      getContentHtml (content) {
        // 未避免被简书转化未设置img的src属性
        return '<p><img width="50px" height="50px" style="margin: -25px 0 0 -25px;"></p><p style="font-size: 20px;margin-left:  -25px;color: yellow;background-color: red;text-align: center;">' + content + '</p>'
      }
    }
  }
</script>

<style scoped>
  .amap-page-container {
    width: 94%;
    height: 94%;
    margin: 1%;
  }

  .amap-demo {
    width: 100%;
    box-sizing: border-box;
    margin: 10px;
    height: 100%;
    overflow: hidden;
  }
</style>
